<template>
    <div>
        <el-container class="mainInfo" v-loading="mainLoading">
            <el-main>
                <toolBar :loading.sync="mainLoading"
                         :menuId="menu_id"
                         :searchData="searchData"
                         @search="search"
                         @doBtn="doBtn">
                </toolBar>
                <tableGrid ref="tableGrid"
                           adaptiveHeight="110"
                           :headList="headList"
                           :dataList="dataList"
                           :pageInfo="pageInfo"
                           @tableOpt="tableOpt"
                           @toPage="toPage"
                           :loading="loading">
                </tableGrid>
            </el-main>
        </el-container>

        <model v-if="showModel"
                    :formData="formData"
                    :loading="dialogLoading"
                    @closeDialog="closeDialog">
        </model>

        <copyDialog v-if="showCopyDialog"
                    :formData="formData"
                    :source_id="source_id"
                    :loading="dialogLoading"
                    @closeDialog="closeDialog"
                    @copySubmitForm="copySubmitForm">>
        </copyDialog>

        <editDialog v-if="showEditDialog"
                    :formData="formData"
                    :loading="dialogLoading"
                    @closeDialog="closeDialog"
                    @submitForm="submitForm">
        </editDialog>
    </div>
</template>

<script>
    import toolBar from '@/components/tools/toolBar'
    import tableGrid from '@/components/tools/table'
    import model from '@/components/flow/model/model'
    import editDialog from '@/components/flow/model/editDialog'
    import copyDialog from '@/components/flow/model/copyDialog'

    export default {
        name: 'flowModel',
        props: ['menuData'],
        components: {
            tableGrid,
            toolBar,
            editDialog,
            model,copyDialog
        },
        data() {
            return {
                mainLoading: false,
                source_id:"",
                menu_id: this.menuData.menuId,
                searchData: {
                    fields: [{
                        tag: "el-input",
                        label: "流程名称",
                        vModel: "keywords",
                    }],
                    formData: {
                        keywords: ""
                    },
                },

                formData: {},
                dataList: [],
                loading: false,
                pageInfo: {
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100],
                    total: 0,
                },

                showModel:false,
                showEditDialog: false,
                showCopyDialog:false,
                dialogLoading: false,

                headList: [
                    {
                        column_name: '_px',
                        column_comment: '序号',
                        column_width: '55'
                    },
                    {
                        column_name: 'NAME_',
                        column_comment: '模型名称',
                        column_width: '150'
                    },
                    {
                        column_name: 'DNAME',
                        column_comment: '分类',
                        column_width: '100',
                    },
                    {
                        column_name: 'CREATE_TIME_',
                        column_comment: '创建时间',
                    },
                    {
                        column_name: 'LAST_UPDATE_TIME_',
                        column_comment: '更新时间',
                    },
                    {
                        column_name: 'VERSION_',
                        prepend:'v.',
                        column_comment: '版本',
                        column_width: '100',
                    },
                    {
                        column_name: "_opt", column_comment: "操作", column_width: "330", opts: [
                            {method: "design", name: "设计", type: "primary", icon: "el-icon-edit-outline"},
                            {method: "deploy", name: "部署", type: "success", icon: "el-icon-reading"},
                            {method: "copy", name: "复制", type: "success", icon: "el-icon-document-copy"}
                        ]
                    },
                ],
            }
        },
        mounted() {
            this.getListData() // 初始化表格数据
        },
        methods: {
            async getListData() {
                this.loading = true;
                let param = {
                    url: "/fhmodel/list",
                    param: {
                        ...this.searchData.formData,
                        pageSize: this.pageInfo.pagesize,
                        currentPage: this.pageInfo.page
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                if (data.infoCode == '0') {
                    this.dataList = data.data.varList;
                    this.pageInfo.total = data.data.page.totalResult;
                }
                this.loading = false;
            },

            toPage() {
                this.getListData();
            },
            search() {
                this.pageInfo.page = 1;
                this.getListData();
            },
            async doBtn(type) {
                let selList = this.$refs.tableGrid.getSelList();
                if (type === "add") {
                    this.formData = {};
                    this.showEditDialog = true;
                }
                if (type === "edit" || type === "delete" || type === "cancel") {
                    this.formData = selList;
                    if (this.$pub.isEmptyObjct(selList)) {
                        this.$message({message: '请先选择一条记录', type: 'error'});
                        return;
                    }

                    if (type === "edit") {
                        this.showModel = true;
                    }

                    if (type === "delete" || type === "cancel") {
                        let param = {
                            url: "/fhmodel/delete",
                            param: {
                                ID_: this.formData.ID_,
                            }
                        }
                        this.$sqlOpt.del.del(param, this, this.getListData);
                    }
                }
            },
            async tableOpt(type, data) {
                this.formData = data;
                if(type==="design"){
                    this.showModel = true;
                }
                else if(type==="deploy"){
                    let param = {
                        url: "/fhmodel/deployment",
                        param: {
                            modelId: this.formData.ID_,
                        }
                    }
                    const data = await this.$store.dispatch('pubMethod', param)
                    if (data.infoCode == '0') {
                        this.$message.success("部署成功")
                    }
                }
                else if(type==="copy"){
                    this.source_id = this.formData.ID_;
                    this.showCopyDialog = true;
                }
            },

            async closeDialog() {
                this.showEditDialog = false;
                this.showCopyDialog = false;
                this.showModel = false;
                await this.getListData();
            },
            async submitForm(form) {
                this.formData = form;
                this.dialogLoading = true;

                let param = {
                    ...this.formData,
                }
                const data = await this.$sqlOpt.save.saveNoToken(param, "/fhmodel/save");
                this.dialogLoading = false;

                if (data.infoCode === '0') {
                    this.$message.success("保存成功");
                    this.closeDialog();
                    await this.getListData();

                    this.formData.ID_ = data.data.sunval;
                    //打开设计器
                    this.showModel = true;
                }
            },
            async copySubmitForm(form) {
                this.formData = form;
                this.dialogLoading = true;

                let param = {
                    ...this.formData,
                }
                const data = await this.$sqlOpt.save.saveNoToken(param, "/fhmodel/copySave");
                this.dialogLoading = false;

                if (data.infoCode === '0') {
                    this.$message.success("复制成功");
                    this.closeDialog();
                    await this.getListData();

                    this.formData.ID_ = data.data.sunval;
                    //打开设计器
                    this.showModel = true;
                }
            },
        }
    }
</script>

<style scoped lang="scss">
    .mainInfo {
        .el-header {
            padding: 0px;
        }

        .el-main {
            padding: 0px;
        }
    }
</style>